'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _logo_music = require('../../../res/images/logo/logo_music.svg');

var _logo_music2 = _interopRequireDefault(_logo_music);

var _logo_qello = require('../../../res/images/logo/logo_qello.svg');

var _logo_qello2 = _interopRequireDefault(_logo_qello);

var _logo_classica = require('../../../res/images/logo/logo_classica.svg');

var _logo_classica2 = _interopRequireDefault(_logo_classica);

var _logo_stingraykaraoke = require('../../../res/images/logo/logo_stingraykaraoke.svg');

var _logo_stingraykaraoke2 = _interopRequireDefault(_logo_stingraykaraoke);

var _logo_smc = require('../../../res/images/logo/logo_smc.svg');

var _logo_smc2 = _interopRequireDefault(_logo_smc);

var _BrandLogos = require('./BrandLogos.scss');

var _BrandLogos2 = _interopRequireDefault(_BrandLogos);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOGOS = [{ src: _logo_music2.default, alt: 'Stingray Music' }, { src: _logo_qello2.default, alt: 'Qello Concerts by Stingray' }, { src: _logo_classica2.default, alt: 'Stingray Classica' }, { src: _logo_stingraykaraoke2.default, alt: 'Stingray Karaoke' }, { src: _logo_smc2.default, alt: 'Singing Machine' }];

var BrandLogos = function BrandLogos() {
  return _react2.default.createElement(
    'ul',
    { className: _BrandLogos2.default.brandLogos, 'aria-label': 'Stingray brands' },
    LOGOS.map(function (_ref) {
      var src = _ref.src,
          alt = _ref.alt;
      return _react2.default.createElement(
        'li',
        { key: alt },
        _react2.default.createElement('img', { src: src, alt: alt, className: _BrandLogos2.default.logo })
      );
    })
  );
};

exports.default = BrandLogos;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/BrandLogos/BrandLogos.js
// module id = 1944
// module chunks = 0